///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class GameOverScreen extends BaseScreen {

        fg:Phaser.GameObjects.Graphics;
        bg:Phaser.GameObjects.Graphics;
        txt:Phaser.GameObjects.Text;
        ronald_mc:Phaser.GameObjects.Sprite;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.bg = new Phaser.GameObjects.Graphics(this.scene);
            this.bg.setPosition(0, 0);
            this.bg.fillStyle(0xFF0000, 1);
            this.bg.fillRect(0, 0, game.scale.width, game.scale.height);
            this.add(this.bg);

            this.add(new Phaser.GameObjects.Image(this.scene, 345,190, 'ui-atlas', 'burger_shadow'+'0000'));
            let lost_burger = new Phaser.GameObjects.Image(this.scene, 345,150, 'ui-atlas', 'lost_burger'+'0000');
            this.add(lost_burger);

            this.txt = this.scene.add.text(game.scale.width/2-75, -100, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 28,
                "color": "#FFFFFF",
                "align": 'center'
            });
            this.txt.setShadow(4, 4, '#000000', 4, true);
            this.txt.setOrigin(0.5, 0.5);
            this.add(this.txt);
            this.txt.setWordWrapWidth(300);
            nscs.gameplay.Gameplay.setText(this.txt, 'GameOver');

            this.ronald_mc = nscs.scene.MainScene.instance.factory.createRonaldSprite()
            this.ronald_mc.setPosition(335, 115);

            this.fg = new Phaser.GameObjects.Graphics(this.scene);
            this.fg.setPosition(0, 0);
            this.fg.fillStyle(0x000000, 1);
            this.fg.fillRect(0, 0, game.scale.width, game.scale.height);
            this.add(this.fg);
            this.scene.tweens.add({
                targets: this.fg,
                alpha: 0,
                duration: 1000,
                onComplete: ()=>{
                    this.remove(this.fg);

                    this.scene.tweens.add({
                        targets: this.txt,
                        y: game.scale.height/2,
                        duration: 1000,
                        ease: Phaser.Math.Easing.Back.Out
                    });

                    this.ronald_mc.play('appear');
                    this.ronald_mc.once('animationcomplete', ()=>{
                        this.ronald_mc.play('laugh');
                        nscs.sound.SoundManager.getInstance().playSound(Phaser.Utils.Array.GetRandom(['laugh1SND','laugh2SND','laugh3SND']))
                        this.ronald_mc.once('animationcomplete', ()=>{
                            this.ronald_mc.play('disappear');
                            this.ronald_mc.once('animationcomplete', ()=>{
                                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene)/*new nscs.screen.HigscoreScreen(this.scene)*/);
                            });
                        });
                    });
                    this.add(this.ronald_mc);
                }
            });
        }
    }
}